import {
  Box,
  Button,
  Chip,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  blackShade01,
  blackShade05,
  blackShade159,
  blackShade19,
  greenShade16,
  greyColor060,
  greyColor13,
  greyColor33,
  greyColor40,
  greyColor9,
  mobilePrimary,
  orderCardBorder,
  whiteColor,
} from "../../configs/styles/muiThemes";
import { stickyHeader } from "../../utils/styles";
import LightToolTip from "../../components/Alerts/LightToolTip";
import ReportSearch from "../../components/Input/ReportSearch";
import ProductDetailCatalogReport from "./ProductDetailCatalogReport";
import {
  clearSearchProducts,
  getActiveBusinessInfo,
  getActiveProductsByBusiness,
  getBusinessPendingProducts,
  getBusinessRejectsProducts,
  getBusinessUpdatedPendingProducts,
  getCommerceInfo,
  getMainProducts,
  getONDCCategories,
  getProductCategories,
  getProductsByBusiness,
  searchBusinessProducts,
} from "../../reducers/businessPreview/businessPreviewSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getInventorySummaryCounts } from "../../reducers/inventory/inventorySlice";
import {
  getActiveBusinessProducts,
  updateSubProductList,
} from "../../reducers/multiBranchCatalog/multiBranchCatalogSlice";
import SearchBoxInput from "../../components/Input/SearchBoxInput";
import ThreeDotLoader from "../../components/ThreeDotLoader";
import SearchInfoCard from "../SubBranchCalalog/Components/SearchInfoCard";
import EmptyCard from "../../components/Alerts/EmptyCard";
import ChildVariantCardPopup from "./Popup/ChildVariantCardPopup";
import ModalCard from "../../components/ModalCard";
import FilterCard from "../newCatalog/FilterCard";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import { addThousandsSeparator, dynamicSort } from "../../utils/helper";
import {
  getMainProductsWithVariantsAPI,
  getONDCProductsAPI,
} from "../../service/api_calls/BusinessPreview/BusinessPreviewAPI";
import { getUserEditEligibility } from "../../reducers/businessOnboard/businessOnboardSlice";
import DescriptionIcon from "@mui/icons-material/Description";
import * as XLSX from "xlsx";
import moment from "moment";
import { getTopSellingProducts } from "../../service/api_calls/ordersReports/OrderReportsAPi";

function CatalogInventoryReportContent() {
  const PAGE_SIZE = 500;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const ondcFilterRef = useRef(null);

  const [showONDCFilter, setShowONDCFilter] = useState(false);

  const [isClearFilter, setIsClearFilter] = useState(null);
  const [filterError, setFilterError] = useState("");
  const [filterLoader, setFilterLoader] = useState(false);
  const [productsList, setProductsList] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [isClearSearch, setIsClearSearch] = useState(false);
  const [filterType, setFilterType] = useState("");

  const [selectedOndcCategory, setSelectedOndcCategory] = useState("All");
  const [selectedOndcSubCat, setSelectedOndcSubCat] = useState("All");
  const [selectedOndcCategoryCode, setSelectedOndcCategoryCode] = useState("");
  const [selectedOndcSubCatCode, setSelectedOndcSubCatCode] = useState("");

  const [categoryList, setCategoryList] = useState([]);
  const [subCatList, setSubCatList] = useState([]);

  const [ondcCategoryList, setOndcCategoryList] = useState([]);
  const [ondcSubCatList, setOndcSubCatList] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedSubCat, setSelectedSubCat] = useState("All");

  const [hasMoreData, setHasMoreData] = useState(true);

  const [viewChildVariant, setviewChildVariant] = useState({
    show: false,
    data: null,
  });
  const [mainProducts, setMainProducts] = useState([]);

  // Open View Order Popup
  const handleViewChildVariants = (data) => {
    setviewChildVariant({ show: true, data });
  };

  const { inventorySummary } = useSelector((state) => state.inventory);
  const {
    activeBusinessInfo,
    businessProducts,
    searchProducts,
    productCategory,
    commerceInfo,
    pendingProducts,
    updatedPendingProducts,
    rejectedProducts,
    businessProductsLoader,
    searchProductsLoader,
    productsByStatusLoader,
    // activeBusinessProductsLoader,
    // activeBusinessProducts,
    totalProductCount,
    // mainProducts,
    mainProductsLoader,
    ondcCategory,
  } = useSelector((state) => state.businessPreview);

  const {
    activeBusinessProducts,
    activeBusinessProductsPageNo,
    activeBusinessProductsLoader,
  } = useSelector((state) => state.multiBranchCatalog);

  const sortByProductName = (products) => {
    return products
      ?.slice()
      ?.sort((a, b) => a?.soldQuantity?.localeCompare(b?.soldQuantity));
  };
  const sortBySoldQuantity = (products) => {
    return products
      ?.slice()
      ?.sort((a, b) => (b?.soldQuantity || 0) - (a?.soldQuantity || 0));
  };

  //search for products
  const handleSearch = () => {
    if (!searchQuery) return;
    clearFilter();
    const businessId = sessionStorage.getItem("selectedBusinessId");
    setSelectedCategory("All");
    setSelectedSubCat("All");
    console.log("searchQuery", searchQuery);

    dispatch(
      searchBusinessProducts({ query: searchQuery, businessId: businessId })
    ).then((res) => {
      if (res?.payload?.details) {
        console.log("SEARCH_RES___:", res?.payload?.details);

        const searchResultList = res?.payload?.details || [];

        const updatedList = [];

        searchResultList.forEach((item) => {
          const result = activeBusinessProducts?.find(
            (product) => product?.id === item?.id
          );

          if (result !== undefined) {
            updatedList.push(result);
          }
        });

        setFilterType("search");
        setIsClearSearch(true);
        setHasMoreData(false);
        dispatch(updateSubProductList({ updatedList: [...updatedList] }));

        // setIsClearFilter({
        //   show: true,
        //   category: `searchQuery`,
        //   message: `Search results for “${searchQuery}”`,
        // });
      }
    });
  };

  // Filter Applied
  const handleOndcFilter = async () => {
    setFilterError("");
    if (ondcCategoryList?.length === 1) {
      setFilterError("ONDC category not assigned for any of the products");

      return;
    }
    if (selectedOndcCategory === "All") {
      setFilterError("Select the Main Category");

      return;
    }

    setFilterLoader(true);
    const businessId = sessionStorage.getItem("selectedBusinessId");
    const categoryData = ondcCategoryList?.filter((item) => {
      return item?.ondcValue === selectedOndcCategory;
    });

    const subCategoryData = ondcSubCatList?.filter((item) => {
      return item?.ondcSubValue === selectedOndcSubCat;
    });

    const ondcProductList = await getONDCProductsAPI({
      businessId,
      params: {
        ondcCode: categoryData?.[0]?.ondcCode,
        ondcSubCode: subCategoryData?.[0]?.ondcSubCode || "",
        pageSize: 500,
        page: 1,
      },
    });
    const pendingList = pendingProducts || [];
    const updatedPendingList = updatedPendingProducts || [];
    const rejectList = rejectedProducts?.details || [];

    console.log("ghjjgjhj", ondcProductList);

    const updatedSearchList = checkActiveProductInPendingRejected(
      ondcProductList,
      [...pendingList, ...updatedPendingList],
      rejectList
    );

    setFilterLoader(false);
    setProductsList(updatedSearchList);

    setShowONDCFilter(false);
    setIsClearFilter({
      show: true,
      category: `${selectedOndcCategory} - ${selectedOndcSubCat}`,
      message: `ONDC Category Filter results for “${selectedOndcCategory} - ${selectedOndcSubCat}” -
      ${ondcProductList?.length ?? 0} products`,
    });
  };

  // Check if active product is also present in pending & Rejected products
  const checkActiveProductInPendingRejected = (
    activeList,
    pendingList,
    rejectList
  ) => {
    const updatedActiveList = activeList?.map((product) => {
      const isPendingProduct = pendingList?.filter((item) => {
        if (item?.variantInfo?.masterProductVariantId) {
          return (
            item?.variantInfo?.masterProductVariantId ===
            product?.variantInfo?.masterProductVariantId
          );
        }
        return item.id === product.id;
      });
      const isRejectedProduct = rejectList?.filter((item) => {
        if (item?.variantInfo?.masterProductVariantId) {
          return (
            item?.variantInfo?.masterProductVariantId ===
            product?.variantInfo?.masterProductVariantId
          );
        }
        return item.id === product.id;
      });

      let updatedOn = "";

      if (isPendingProduct?.length > 0) {
        updatedOn = isPendingProduct?.[0]?.productUpdatedOn;
      }

      if (isRejectedProduct?.length > 0) {
        updatedOn = isRejectedProduct?.[0]?.productUpdatedOn;
      }

      return {
        ...product,
        disableEdit: isPendingProduct?.length > 0,
        isPendingProduct: isPendingProduct?.length > 0,
        isRejectedProduct: isRejectedProduct?.length > 0,

        tempisPendingProduct: isPendingProduct,
        tempisRejectedProduct: isRejectedProduct,
        updatedOn,
      };
    });

    return updatedActiveList;
  };

  const handleOndcCategoryChange = (data) => {
    setSelectedOndcCategory(data);
    setSelectedOndcSubCat("All");

    if (data === "All") {
      setOndcSubCatList([]);
      return;
    }

    setFilterError("");

    const categoryData = ondcCategoryList?.filter((item) => {
      return item?.ondcValue === data;
    });

    formatCategory(
      categoryData?.[0]?.productSubCategory,
      setOndcSubCatList,
      "ondcSubValue"
    );
  };

  const handleOndcSubCategoryChange = (data) => {
    setSelectedOndcSubCat(data);
  };

  // Prepare list data for filter dropdown
  const formatCategory = (category, setValue, valueSelector) => {
    const sortedArray = category?.slice()?.sort(dynamicSort(valueSelector));
    const catList = sortedArray?.map((item) => {
      return { ...item, label: item?.[valueSelector] };
    });

    setValue([{ label: "All" }, ...catList]);
  };

  // Fetch active Business Products
  const fetchActiveBusinessProducts = (isRefresh) => {
    setHasMoreData(true);
    const businessId = sessionStorage.getItem("selectedBusinessId");

    if (isRefresh) {
      dispatch(
        getActiveBusinessProducts({
          businessId,
          pageSize: PAGE_SIZE,
          pageNo: 1,
          isRefresh: true,
        })
      ).then((res) => {
        if (
          res?.payload?.productList?.length == 0 ||
          res?.payload?.productList?.length < PAGE_SIZE
        ) {
          setHasMoreData(false);
        }
      });

      return;
    }

    dispatch(
      getActiveBusinessProducts({
        businessId,
        pageSize: PAGE_SIZE,
        pageNo: activeBusinessProductsPageNo,
      })
    ).then((res) => {
      if (
        res?.payload?.productList?.length == 0 ||
        res?.payload?.productList?.length < PAGE_SIZE
      ) {
        setHasMoreData(false);
      }
    });
  };

  // Clear Search
  const clearSearch = () => {
    dispatch(clearSearchProducts());
    fetchActiveBusinessProducts(true);

    setSearchQuery("");
    setIsClearSearch(false);
    // setIsClearFilter(false);
    setFilterType("");

    setSelectedCategory("All");
    setSelectedSubCat("All");
    setOndcSubCatList([]);
    // setSelectedOndcCategory("All");
    // setSelectedOndcSubCat("All");
    setSubCatList([]);
  };

  const clearFilter = () => {
    setSelectedCategory("All");
    setSelectedSubCat("All");
    setSubCatList([]);
    setOndcSubCatList([]);

    setIsClearFilter(null);
  };
  const onOndcFilterClose = () => {
    setFilterError("");
    setShowONDCFilter(false);
    setSelectedOndcCategory("All");
    setSelectedOndcSubCat("All");
    setOndcSubCatList([]);
  };
  const clearAllOndcFilterData = () => {
    setSelectedOndcCategory("All");
    setSelectedOndcSubCat("All");
    setOndcSubCatList([]);
  };

  const getAllMainProductsWithVariants = async (
    ondcCode,
    ondcSubCode,
    search
  ) => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    const response = await getMainProductsWithVariantsAPI(
      businessId,
      ondcCode,
      ondcSubCode,
      search
    );
    const array = [...response?.details];
    console.log("getMainProductsAPI Hit");
    const catalogSold = await getTopSellingProducts(businessId);
    console.log("pradeep_123_catalogSold", catalogSold);
    array.forEach((item) => {
      // Check if the current item has a master property
      if (item.id) {
        // Find a matching item in the second array
        const match = catalogSold?.details?.find(
          (e) => e.productId === item.id
        );

        if (match) {
          item.soldQuantity = match.totalQuantity;
          console.log("find123", (item.soldQuantity = match.totalQuantity));
        }
      }
    });
    console.log("getAllMainProductsWithVariants", response);
    setMainProducts(array || []);
  };

  const onDownload = async ({ ondcCode, ondcSubCode, search }) => {
    //  if (isDownloaded) return;
    //  setIsDownloaded(true);

    //  const selectedProducts = productList?.filter((item) => item?.isSelected);
    const businessName = sessionStorage.getItem("costboWEBURL");
    const businessId = sessionStorage.getItem("selectedBusinessId");
    const categoryCode = ondcCategoryList?.filter((item) => {
      return item?.ondcValue === ondcCode ? item?.ondcCode : "";
    });
    const response = await getMainProductsWithVariantsAPI(
      businessId,
      ondcCode,
      ondcSubCode,
      search
    );

    const array = [...response?.details];
    console.log("getMainProductsAPI Hit");
    const catalogSold = await getTopSellingProducts(businessId);
    console.log("pradeep_123_catalogSold", catalogSold);
    array.forEach((item) => {
      // Check if the current item has a master property
      if (item.id) {
        // Find a matching item in the second array
        const match = catalogSold?.details?.find(
          (e) => e.productId === item.id
        );

        if (match) {
          item.soldQuantity = match.totalQuantity;
          console.log("find123", (item.soldQuantity = match.totalQuantity));
        }
      }
    });

    console.log("getMainProductsAPI Hit1", array);

    console.log("response123", ondcCode, ondcSubCode, response);

    ExcelDownload(
      // isClearFilter
      //   ? sortBySoldQuantity(productsList)
      //   : isClearSearch
      //   ? sortBySoldQuantity(searchProducts?.details)
      //   : sortBySoldQuantity(mainProducts),
      // response?.details?.length > 0 ? array:response?.details,
      response?.details?.length > 0
        ? isClearFilter
          ? sortBySoldQuantity(productsList)
          : isClearSearch
          ? sortBySoldQuantity(searchProducts?.details)
          : sortBySoldQuantity(array)
        : response?.details,
      `${businessName}_Catalog_Inventory_Report_${moment().format(
        "Do_MM_YYYY"
      )}`,
      businessName
    );

    // if (isCatalogPartner) {
    //   exportToExcelCatalogPartnerData(
    //     selectedProducts,
    //     `${businessName}_Inventory_Details_${moment().format("Do_MM_YYYY")}`,
    //     businessName
    //   );
    // } else {
    //   exportToExcel(
    //     selectedProducts,
    //     `${businessName}_Inventory_Details_${moment().format("Do_MM_YYYY")}`,
    //     businessName
    //   );
    // }

    setTimeout(() => {
      //  setIsDownloaded(false);
    }, 2000);
  };

  const ExcelDownload = (data, fileName = "products", businessName) => {
    if (!data || data.length === 0) {
      console.error("No data provided for export.");
      return;
    }

    // Define headers with warnings
    const headers = [
      ["Catalog Inventory Report"],
      [
        `${businessName}`,
        `Catalog Report date ${moment().format("Do MMM YYY")}`,
      ],
      //  ["", "DO NOT EDIT PRODUCT IDs", "DO NOT EDIT PRODUCT NAMEs"],
      [
        "S.no",
        // "Product Id",
        "Product Name",
        "ONDC Category",
        "ONDC Sub Category",
        "Availability",
        // "Available Quantity",
        "Original Price",
        "Sale Price",
        "Sold Quantity",
        // "No. of Variants",
      ],
    ];

    // Format data rows
    const formattedData = data.map(
      (
        // {
        //   // id,
        //   productName,
        //   productMainCategory?.[0]?.ondcValue,
        //   availableQuantity,
        //   productOriginalPrice,
        //   productSalePrice,
        // }
        item,
        index
      ) => [
        index + 1,
        // id,
        item?.productName,
        item?.productMainCategory?.[0]?.ondcValue,
        item?.productSubCategory?.[0]?.ondcSubValue,
        item.availability?.[0] == "Yes" ? "Yes" : "No",
        // item?.availableQuantity,
        ` ₹ ${addThousandsSeparator(item?.productOriginalPrice)}`,
        ` ₹ ${addThousandsSeparator(item?.productSalePrice)}`,
        item?.soldQuantity || 0,
        // item?.variantInfo?.masterProductVariantId ? item?.count : "-",
      ]
    );

    // Combine headers and data
    const finalData = [...headers, ...formattedData];

    // Convert to worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(finalData);

    // Create workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

    // Write workbook and create Blob
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const excelBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create download link
    const url = URL.createObjectURL(excelBlob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.xlsx`;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // Fetching all the Catalog Data
  useEffect(() => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    if (businessId) {
      // getStatsInfo();
      if (activeBusinessProducts?.length == 0) {
        dispatch(getActiveProductsByBusiness({ businessId, pageNo: 1 }));
      }
      if (mainProducts?.length == 0) {
        dispatch(getMainProducts(businessId));
      }

      // if (!editEligibility) {
      //   dispatch(getUserEditEligibility());
      // }
      if (!activeBusinessInfo) {
        dispatch(getActiveBusinessInfo(businessId));
      }
      // if (!businessProducts) {
      //   dispatch(getProductsByBusinesss(businessId));
      // }
      // if (!productCategory) {
      //   dispatch(getProductCategories(businessId));
      // }
      if (!ondcCategory) {
        dispatch(getONDCCategories(businessId));
      }
      if (!commerceInfo) {
        dispatch(getCommerceInfo(businessId));
      }
      if (!pendingProducts) {
        dispatch(getBusinessPendingProducts({ businessId, status: "new" }));
      }
      if (!updatedPendingProducts) {
        dispatch(
          getBusinessUpdatedPendingProducts({ businessId, status: "updated" })
        );
      }
      if (!rejectedProducts) {
        dispatch(
          getBusinessRejectsProducts({ businessId, status: "declined" })
        );
      }

      // // Getting Product and Sales Count
      // if (!statsCountInfo) {
      //   dispatch(getStatsCountInfoData(businessId));
      // }
    }

    return () => {
      console.log("CLEAR_DATA_CATALOG");
      // dispatch(clearCatalogData());
    };
  }, []);

  useEffect(() => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    getAllMainProductsWithVariants();
    // if (businessId) {
    //   if (mainProducts?.length == 0) {
    //     dispatch(getMainProducts(businessId));
    //   }
    // }

    if (!inventorySummary) {
      dispatch(getInventorySummaryCounts(businessId));
    }
  }, []);
  useEffect(() => {
    if (ondcCategory) {
      const ondcFilteredCategory = ondcCategory?.map(
        ({ _id, productSubCategory }) => ({
          ondcCode: _id?.ondcCode,
          ondcValue: _id?.ondcValue,
          productSubCategory,
        })
      );
      // const ondcFilteredCategory = ondcCategory?.filter(
      //   (item) => item?.ondcCode
      // );
      formatCategory(ondcFilteredCategory, setOndcCategoryList, "ondcValue");
      console.log("ondcCategory", ondcCategory, ondcFilteredCategory);
    }
  }, [ondcCategory]);

  return (
    <Box
      sx={{
        background: whiteColor,
        //  marginBottom: "24px",
        borderRadius: "10px",
        padding: { xs: "20px 15px", md: "15px" },
        mt: "15px",
        // textAlign: "center",
        border: "1px solid #e5e9f0",
        boxShadow: "0 3px 4px rgb(229 233 240 / 22%)",
        // marginTop: "15px",
        // minHeight: { xs: "calc(100vh - 91px)", md: "100vh" },
      }}
    >
      {mainProductsLoader ? (
        <ThreeDotLoader />
      ) : (
        <Box
          sx={{
            ...stickyHeader,
            pb: { md: 1, xs: 0 },
            pt: 0,
            // top: 248,
            display: { md: "block", xs: "none" },
            backgroundColor: whiteColor,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                variant="h5"
                color={blackShade05}
                fontSize={{ xs: "14.5px", md: "15px" }}
                fontWeight="600"
                //  sx={stickyHeader}
              >
                Catalog Report{" "}
                {inventorySummary?.totalProduct?.length > 0 && (
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: "400",
                      color: greyColor40,
                    }}
                  >
                    -{" "}
                    {!inventorySummary
                      ? "XX"
                      : `${inventorySummary?.totalProduct} ${
                          inventorySummary?.totalProduct?.length === 1
                            ? "product"
                            : "products"
                        }`}
                  </span>
                )}
              </Typography>
              {/* <Typography
              component="h5"
              fontSize={{ xs: 15, md: 15 }}
              color={blackShade05}
              fontWeight={600}
              lineHeight="20px"
            >
              Available to Order{" "}
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: "400",
                  color: greyColor40,
                }}
              >
                -{" "}
                {!inventorySummary
                  ? "XX"
                  : `${inventorySummary?.totalProduct} ${
                      inventorySummary?.totalProduct?.length === 1
                        ? "product"
                        : "products"
                    }`}
              </span>
            </Typography> */}
            </Box>
            {mainProducts.length > 0 && (
              <Box display={"flex"} gap={3} mt={0.5}>
                {/* <ReportSearch
              placeholder="Search by Product"
              radius={"50px"}
              // value={searchValues.ondcOrderId}
              // onChange={(value) =>
              //   setSearchValues({ ...searchValues, ondcOrderId: value })
              // }
            /> */}
                <ReportSearch
                  label=""
                  placeholder="Search by Product"
                  value={searchQuery}
                  radius={"50px"}
                  onChange={(text) => {
                    setSearchQuery(text);
                  }}
                  onSearchClick={handleSearch}
                  isDashboardInput
                />
                <Box
                  display={"flex"}
                  gap={1}
                  position={{ xs: "relative", md: "static" }}
                  mt={{ xs: 0, md: 0 }}
                >
                  <Box
                    position={{ md: "relative", xs: "static" }}
                    ref={ondcFilterRef}
                  >
                    <Button
                      sx={styles.filterIconBtn}
                      variant="contained"
                      disableElevation
                      onClick={() => {
                        clearSearch();
                        setIsClearFilter(null);
                        setShowONDCFilter((prev) => !prev);
                      }}
                      endIcon={
                        <FilterListRoundedIcon sx={{ fontSize: "17px" }} />
                      }
                    >
                      {matches ? "ONDC Category Filters" : "ONDC Category"}
                    </Button>
                    {showONDCFilter && (
                      <FilterCard
                        title="ONDC Category Filters"
                        categoryList={ondcCategoryList}
                        subCategoryList={ondcSubCatList}
                        selectedCategory={selectedOndcCategory}
                        selectedSubCategory={selectedOndcSubCat}
                        handleCategoryChange={handleOndcCategoryChange}
                        handleSubCategoryChange={handleOndcSubCategoryChange}
                        onApply={handleOndcFilter}
                        onCancel={onOndcFilterClose}
                        onAllClear={clearAllOndcFilterData}
                        loader={filterLoader}
                        error={filterError}
                      />
                    )}
                  </Box>
                  <Button
                    sx={styles.actionBtn}
                    // disabled
                    disabled={searchQuery}
                    startIcon={<DescriptionIcon />}
                    onClick={() => {
                      // const mainCatCode = categoryData?.ondcCode || "";
                      // const subCatCode = subCategoryData?.ondcSubCode || "";
                      const categoryData = ondcCategoryList?.find((item) => {
                        return item?.ondcValue === selectedOndcCategory;
                      });

                      const subCategoryData = ondcSubCatList?.find((item) => {
                        return item?.ondcSubValue === selectedOndcSubCat;
                      });

                      onDownload({
                        ondcCode: categoryData?.ondcCode,
                        ondcSubCode: subCategoryData?.ondcSubCode,
                        search: searchQuery,
                      });
                    }}
                  >
                    Excel Download
                  </Button>
                </Box>

                {/* <ReportSearch
                placeholder="Search by category"
                radius={"50px"}
                // value={searchValues.ondcOrderId}
                // onChange={(value) =>
                //   setSearchValues({ ...searchValues, ondcOrderId: value })
                // }
              /> */}
                {/* <Box display={"flex"} gap={2}>
              <LightToolTip
                title={"Functionality not Implemented"}
                placement="right"
              >
                <IconButton
                  sx={styles.backBtn}
                  variant="contained"
                  disableElevation
                  // onClick={() => exportToExcel(orderReportsData)}
                  // startIcon={}
                >
                  <Box
                    component="img"
                    maxHeight={{ xs: "29px", md: "40px" }}
                    src={`/./assets/image/pdf-icon-04.svg`}
                    alt="CostBo"
                  />
                </IconButton>
              </LightToolTip>
            </Box> */}
              </Box>
            )}
          </Box>
          {isClearSearch && (
            <Box mt={{ xs: 2.5, md: 1.3 }}>
              <SearchInfoCard
                searchQuery={searchQuery}
                clearSearch={() => {
                  clearSearch();
                }}
                // filterType={filterType}
                clearFilter
                // isClearFilter={isClearFilter}
              />
            </Box>
          )}
          {isClearFilter?.show ? (
            <Box
              display="flex"
              alignItems="center"
              gap="6px"
              mt={1}
              flexWrap={"wrap"}
            >
              <Typography
                component="h4"
                fontSize={12}
                color={blackShade05}
                fontWeight={500}
                lineHeight="20px"
              >
                {isClearFilter?.message}
              </Typography>

              <Chip
                label={isClearFilter?.category}
                sx={{ fontSize: "12px", height: "28px" }}
                onDelete={() => {
                  clearFilter();
                  clearAllOndcFilterData();
                }}
              />
            </Box>
          ) : null}
          {mainProducts.length > 0 ? (
            <>
              <Box sx={styles.card} mt={2}>
                <Grid container spacing={2}>
                  <Grid item xs={6} md={4}>
                    <Typography
                      variant="h5"
                      fontSize={12}
                      fontWeight={400}
                      color={greyColor060}
                    >
                      Product Info
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={2}>
                    <Typography
                      variant="h5"
                      fontSize={12}
                      fontWeight={400}
                      color={greyColor060}
                    >
                      Category & Sub Category
                    </Typography>
                  </Grid>{" "}
                  {mainProducts?.[0]?.catalogPartnerItemInfo?.length === 0 && (
                    <Grid item xs={6} md={1}>
                      <Typography
                        variant="h5"
                        fontSize={12}
                        fontWeight={400}
                        color={greyColor060}
                      >
                        Availability
                      </Typography>
                    </Grid>
                  )}
                  <Grid item xs={6} md={1.5}>
                    <Typography
                      variant="h5"
                      fontSize={12}
                      fontWeight={400}
                      color={greyColor060}
                    >
                      Available QTY
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={2.5}>
                    <Typography
                      variant="h5"
                      fontSize={12}
                      fontWeight={400}
                      color={greyColor060}
                    >
                      Price
                    </Typography>
                  </Grid>
                  {/* <Grid item xs={6} md={1.2}>
              <Typography
                variant="h5"
                fontSize={12}
                fontWeight={400}
                color={greyColor060}
              >
                Original Price
              </Typography>
            </Grid>
            <Grid item xs={12} md={1.2}>
              <Typography
                variant="h5"
                fontSize={12}
                fontWeight={400}
                color={greyColor060}
              >
                Sale Price
              </Typography>
            </Grid>
            <Grid item xs={12} md={0.8}>
              <Typography
                variant="h5"
                fontSize={12}
                fontWeight={400}
                color={greyColor060}
              >
                Discount
              </Typography>
            </Grid> */}
                  <Grid item xs={12} md={1}>
                    <Typography
                      variant="h5"
                      fontSize={12}
                      fontWeight={400}
                      color={greyColor060}
                    >
                      Sold QTY
                    </Typography>
                  </Grid>
                  {/* <Grid item xs={12} md={0.8}>
                    <Typography
                      variant="h5"
                      fontSize={12}
                      fontWeight={400}
                      color={greyColor060}
                    >
                      Variant
                    </Typography>
                  </Grid> */}
                </Grid>
              </Box>
              <Box
                sx={{
                  height: mainProducts?.length > 6 ? "65vh" : "auto",
                  overflowY: "auto",
                  scrollbarWidth: "thin",
                  "&::-webkit-scrollbar": {
                    width: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#888",
                    borderRadius: "6px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f0f0f0",
                  },
                }}
              >
                {/* {mainProducts?.map((item, index) => {
            return <ProductDetailCatalogReport item={item} />;
          })} */}
                {/* {sortByProductName(activeBusinessProducts)?.map((item, index) => (
              <ProductDetailCatalogReport key={index} item={item} />
            ))} */}
                {(isClearFilter
                  ? sortBySoldQuantity(productsList)
                  : isClearSearch
                  ? sortBySoldQuantity(searchProducts?.details)
                  : sortBySoldQuantity(mainProducts)
                )?.map((item, index) => (
                  <ProductDetailCatalogReport
                    key={index}
                    item={item}
                    handleViewChildVariants={handleViewChildVariants}
                  />
                ))}

                {isClearSearch && searchProducts?.details?.length === 0 && (
                  <Box>
                    <EmptyCard
                      icon={"/./assets/icon/catalog-inventory-empty.svg"}
                      iconWidth={"98px"}
                      iconHeight={"85px"}
                      message={"No Catalog matching the filter criteria"}
                      hideBtn
                      margin
                      paddingY={"30px"}
                    />
                  </Box>
                )}
              </Box>
            </>
          ) : (
            <Box mt={2}>
              <EmptyCard
                icon={"/./assets/icon/catalog-inventory-empty.svg"}
                iconWidth={"98px"}
                iconHeight={"85px"}
                message={"Catalog details are not available"}
                hideBtn
                margin
                paddingY={"30px"}
              />
            </Box>
          )}
        </Box>
      )}
      <ModalCard
        open={viewChildVariant?.show}
        handleClose={() => {
          setviewChildVariant({ show: false, data: null });
        }}
        width="80%"
      >
        <ChildVariantCardPopup mainVariant={viewChildVariant?.data || null} />
      </ModalCard>
    </Box>
  );
}

export default CatalogInventoryReportContent;

const styles = {
  card: {
    display: { md: "flex", xs: "none" },
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: "16px", md: "20px" },
    backgroundColor: whiteColor,
    // backgroundColor: greyColor42,
    border: orderCardBorder,
    borderRadius: "7px 7px 0px 0px",
    boxShadow: "0 2px 4px rgb(179 188 198 / 5%)",
    padding: "7px 15px",
    position: "sticky",
    top: 150,
    zIndex: 10000,
    // marginBottom: "15px",
  },
  backBtn: {
    width: "40px",
    height: "35px",
    backgroundColor: "#f1f4f7",
    padding: { md: "10px !important", xs: "3px 6px !important" },
    fontSize: "14px",
    color: { xs: mobilePrimary, md: blackShade159 },
    textTransform: "unset",
    textDecoration: "underline",
    border: {
      xs: "1px solid " + "#E4E7F4",
      md: "1px solid " + "#E4E7F4",
    },
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "transparent",
      color: { xs: mobilePrimary, md: greyColor13 },
    },
  },
  toggleBtn: {
    width: "32px",
    height: "32px",
    backgroundColor: whiteColor,
    padding: { md: "6px !important", xs: "3px 6px !important" },
    fontSize: "11px",
    color: { xs: mobilePrimary, md: greyColor060 },
    textTransform: "unset",
    textDecoration: "underline",
    border: {
      xs: "1px solid " + "#E4E7F4",
      md: "1px solid " + "#E4E7F4",
    },
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: "transparent",
      color: { xs: mobilePrimary, md: greyColor060 },
    },
  },
  filterIconBtn: {
    height: "35px",
    padding: "4px 12px",
    fontSize: "11px",
    fontWeight: 600,
    color: "#3f454f",
    backgroundColor: whiteColor,
    border: "1px solid " + "#d4dae0",
    "&:hover": {
      color: whiteColor,
      backgroundColor: greyColor9,
    },
  },
  tableBodyCell: (color) => ({
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: color || blackShade01,
    padding: "10px 16px !important",
  }),
  actionBtn: {
    fontSize: 11,
    fontWeight: 600,
    lineHeight: "22px",
    color: greenShade16,
    border: `1px solid ${greenShade16}`,
    backgroundColor: whiteColor,
    p: "2px 8px",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: greenShade16,
      color: whiteColor,
    },
    "&:disabled": {
      border: `1px solid ${greyColor33}`,
      opacity: 0.6,
    },
  },
};
